import { Stack } from '@mui/material';
import { DialogProps } from '../../../interfaces/interfaces';
import { Popup } from '../../popup/popup';
import { ButtonStyled } from './logoutConfirmationStyles';
import { useTranslation } from 'react-i18next';
import { store } from '../../../redux/store';
import { logout as authLogout } from '../../../redux/reducers/authReducer';

export function LogoutConfirmation(props: DialogProps) {
  const { onClose, open } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  const logout = async () => {
    store.dispatch(authLogout());
    onClose();
  };

  return (
    <Popup
      onClose={() => handleClose}
      open={open}
      closeButton={false}
      dialogTitle={t('account:confirmationLogout')}
      dialogActions={
        <Stack direction="row" justifyContent="space-evenly" alignItems="center" sx={{ width: '100%' }}>
          <ButtonStyled onClick={() => onClose()} variant="contained">
            {t('account:confirmationNo')}
          </ButtonStyled>
          <ButtonStyled onClick={() => logout()} variant="contained">
            {t('account:confirmationYes')}
          </ButtonStyled>
        </Stack>
      }
    />
  );
}
